// src/pages/LoginPage.tsx
import { useState } from 'react';
import './Login.css';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import api from '../../services/api';
// import api from '../../services/api'; // Asegúrate de que la ruta sea correcta

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // const BORDERGARITA_API_URL = process.env.REACT_APP_BORDERGARITA_API_URL || 'https://api.bordergarita.com';
      setLoading(true);
      const response = await api.post('/auth/login', {
        username,
        password
      });

      console.log('response...', response)
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      window.location.href = '/entry_pages';
    } catch (err) {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src="/logo.png" alt="Logo" width={180} height={'auto'} style={{ marginBottom: '3rem' }} />
        <form
          onSubmit={handleLogin}
          style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1rem' }}
          className=""
        >
          <InputText
            type="text"
            placeholder="Username"
            className="w-100"
            value={username}
            disabled={loading}
            onChange={(e) => setUsername(e.target.value)}
            required
            style={{ width: '100%' }}
          />
          <InputText
            type="password"
            placeholder="Password"
            className="w-100"
            value={password}
            disabled={loading}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: '100%' }}
          />
          {error && <div className="login-error" style={{ width: '100%' }}>{error}</div>}
          <Button label='Login' loading={loading} className="login-button" type="submit"></Button>
        </form>
      </div>
    </div>
  );
}
